export const PROFILE = {
  name: "Maulana Malik Ibrahim",
  role: "Full Stack Developer",
  summary:
    "I build web systems end to end, from database design and backend APIs to the interface people actually use. My focus is Laravel and Next.js applications for business operations such as payroll, loan management, and internal tooling.",
  location: "Bondowoso, ID",
  status: "Available for new Oppurtunity",
  focus: "Business Systems, Web Apps, & AI Dev",
  timezone: "Asia/Jakarta",
  email: "mmalikibrahim666@gmail.com",
  resume: "/CV%20MAULANA%20MALIK%20IBRAHIM.pdf",
  github: "https://github.com/LuciferLovesMe",
  linkedin: "https://www.linkedin.com/in/maulana-malik-ibrahim-7b4539216/",
  instagram: "https://www.instagram.com/abeemm666/",
};

export const STACK_GROUPS = [
  {
    "label": "NLP & Text Systems",
    "blurb": "Information extraction, text classification, semantic search and domain-specific tokenization pipelines.",
    "items": [
      "Python",
      "Hugging Face",
      "BERT",
      "Transformers",
      "spaCy",
      "NLTK",
      "WordPiece",
      "NER Pipelines"
    ]
  },
  {
    "label": "Backend & Systems",
    "blurb": "Resilient services, scalable RESTful APIs and relational database engineering.",
    "items": [
      // "Go",
      "Node.js",
      "Laravel",
      "PostgreSQL",
      "MySQL",
      "ASP.Net",
      "REST APIs",
      "Query Optimization"
    ]
  },
  {
    "label": "Frontend Interfaces",
    "blurb": "Responsive user interfaces, complex state management and reusable design systems.",
    "items": [
      "React",
      "Next.js",
      "TypeScript",
      "Tailwind CSS",
      // "Complex State Architecture",
      // "Client Performance"
    ]
  },
  {
    "label": "Workflow & QA Testing",
    "blurb": "Version control discipline, automated CI checks and thorough functional testing.",
    "items": [
      "Git Flow",
      "GitHub Actions (CI)",
      "Manual System Testing",
      "Regression Testing",
      "Postman API Testing"
    ]
  }
];

export const EXPERIENCES = [
  {
    period: "June 2026 — Present",
    role: "Full Stack Developer",
    company: "PT. Univerz Teknologi Utama",
    points: [
      "Architected and developed core Enterprise Resource Planning (ERP) modules across finance, inventory, and operations to streamline cross-departmental business workflows.",
      "Engineered secure RESTful APIs and optimized relational database schemas (MySQL) with Laravel to maintain high data integrity for high-volume enterprise transactions.",
      "Built responsive, user-friendly frontend interfaces utilizing React, translating complex operational workflows into intuitive dashboards and interactive data tables.",
      "Collaborated with cross-functional teams to translate complex business rules into scalable, maintainable software architectures and reliable data pipelines.",
    ],
    technologies: [
      "Laravel",
      "React.js",
      "MySQL",
      "Accounting"
    ],
  },
  {
    period: "Aug 2025 — Dec 2025",
    role: "Intern",
    company: "PT. Ina Gata Persada (Inagata Technosmith)",
    points: [
      "Developed and maintained custom software solutions tailored to diverse corporate client requirements.",
      "Translated UI/UX designs into responsive and interactive frontend interfaces utilizing Vue.JS.",
      "Engineered robust RESTful APIs with Laravel to facilitate seamless data exchange between server-side logic and client applications.",
    ],
    technologies: ["Vue.js", "Laravel", "MySQL", "PostgreSQL", "TailwindCSS"],
  },
  {
    period: "Feb 2025 — Jul 2025",
    role: "AI Engineer Bootcamp",
    company: "Dicoding × DBS Foundation (Coding Camp)",
    points: [
      "Completed an intensive AI Engineering Bootcamp, developing practical expertise in Machine Learning, Deep Learning, and Data Science methodologies.",
      "Built and trained predictive models utilizing Python, enhancing analytical problem-solving skills and expanding technical versatility beyond traditional web development.",
    ],
    technologies: ["Python", "Machine Learning", "Data Science", "Deep Learning"],
  },
  {
    period: "Aug 2024 — Dec 2024",
    role: "Intern",
    company: "BRIN & Datains",
    points: ["Built and optimized modern web applications utilizing Next.js, focusing on performance rendering and seamless user experience."],
    technologies: ["Next.js", "MySQL", "PostgreSQL"],
  },
  {
    period: "Oct 2022 — Apr 2024",
    role: "Backend Developer",
    company: "PT. Barouk Raya Teknologi",
    points: [
      "Developed and deployed core software solutions specific to banking operations for Bank BPR UMKM Jawa Timur.",
      "Architected secure backend systems and RESTful APIs using Laravel, implementing strict data validation and secure authentication logic.",
      "Collaborated closely with cross-functional teams to integrate complex server-side functionalities with intuitive user-facing elements.",
    ],
    technologies: ["Laravel", "REST API", "AJAX", "JavaScript"],
  },
  {
    period: "Jan 2021 — Apr 2021",
    role: "Intern Backend Developer",
    company: "JV. Partner Indonesia",
    points: [
      "Contributed to the development and feature enhancement of web applications using the Laravel framework.",
      "Actively participated in peer code reviews, providing technical feedback to optimize code quality, maintainability, and system performance.",
    ],
    technologies: ["PHP", "Laravel", "AJAX", "MySQL"],
  },
];

export const CLIENTS = [
  "Bank BPR UMKM Jawa Timur",
  "Inagata Technosmith",
  "BRIN",
  "Barouk Raya Teknologi",
  "Yayasan Dimsa",
  "SMKN 1 Bondowoso",
];
